import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "wrapper" }
const _hoisted_2 = {
  id: "modal_arming",
  class: "modal fade show",
  tabindex: "-1",
  "data-backdrop": "static"
}
const _hoisted_3 = { class: "modal-dialog modal-sm" }
const _hoisted_4 = { class: "modal-content" }
const _hoisted_5 = { class: "modal-header justify-content-center text-center" }
const _hoisted_6 = { class: "modal-title" }
const _hoisted_7 = { class: "font-italic font-weight-bold" }
const _hoisted_8 = /*#__PURE__*/_createTextVNode()
const _hoisted_9 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_10 = { class: "modal-body d-flex flex-column align-items-center p-3" }
const _hoisted_11 = { class: "w-100" }
const _hoisted_12 = { class: "mt-3 font-size-lg float-right" }
const _hoisted_13 = { class: "font-weight-bold mb-4" }
const _hoisted_14 = { class: "row dashboard" }
const _hoisted_15 = { class: "col-12 col-lg-6" }
const _hoisted_16 = { class: "card" }
const _hoisted_17 = { class: "card-header d-flex flex-row justify-content-between align-items-center" }
const _hoisted_18 = { class: "card-title d-flex flex-column" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("span", null, "Anlagen", -1)
const _hoisted_20 = { class: "text-muted" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-refresh" }, null, -1)
const _hoisted_22 = [
  _hoisted_21
]
const _hoisted_23 = {
  key: 0,
  class: "card-body bg-body p-3 text-center"
}
const _hoisted_24 = /*#__PURE__*/_createElementVNode("h6", { class: "text-dark" }, "Keine Daten vorhanden ", -1)
const _hoisted_25 = /*#__PURE__*/_createElementVNode("a", {
  href: "#",
  class: "btn btn-link"
}, "Zu den ...", -1)
const _hoisted_26 = [
  _hoisted_24,
  _hoisted_25
]
const _hoisted_27 = {
  key: 1,
  class: "media-list media-list-linked media-list-bordered"
}
const _hoisted_28 = ["onClick"]
const _hoisted_29 = { class: "mr-3 d-flex flex-column align-items-center" }
const _hoisted_30 = { class: "media-body d-flex flex-column flex-lg-row align-items-lg-center" }
const _hoisted_31 = { class: "flex-fill d-flex flex-column" }
const _hoisted_32 = { class: "text-muted" }
const _hoisted_33 = { class: "text-muted" }
const _hoisted_34 = { class: "text-muted" }
const _hoisted_35 = {
  key: 0,
  class: "ml-lg-3 mt-3 mt-lg-1"
}
const _hoisted_36 = ["onClick"]
const _hoisted_37 = /*#__PURE__*/_createElementVNode("i", { class: "fal fa-temperature-down" }, null, -1)
const _hoisted_38 = /*#__PURE__*/_createTextVNode(" kleinen Schwellwert einschalten ")
const _hoisted_39 = [
  _hoisted_37,
  _hoisted_38
]
const _hoisted_40 = ["onClick"]
const _hoisted_41 = /*#__PURE__*/_createElementVNode("i", { class: "fal fa-temperature-up" }, null, -1)
const _hoisted_42 = /*#__PURE__*/_createTextVNode(" kleinen Schwellwert ausschalten ")
const _hoisted_43 = [
  _hoisted_41,
  _hoisted_42
]
const _hoisted_44 = ["onClick"]
const _hoisted_45 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-bell-on" }, null, -1)
const _hoisted_46 = /*#__PURE__*/_createTextVNode(" scharf schalten ")
const _hoisted_47 = [
  _hoisted_45,
  _hoisted_46
]
const _hoisted_48 = ["onClick"]
const _hoisted_49 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-bell-slash" }, null, -1)
const _hoisted_50 = /*#__PURE__*/_createTextVNode(" unscharf schalten ")
const _hoisted_51 = [
  _hoisted_49,
  _hoisted_50
]
const _hoisted_52 = { class: "col-12 col-lg-6" }
const _hoisted_53 = {
  key: 0,
  class: "card"
}
const _hoisted_54 = /*#__PURE__*/_createElementVNode("div", { class: "card-header" }, [
  /*#__PURE__*/_createElementVNode("h6", { class: "card-title" }, "Importierte Kontakte / Benutzer")
], -1)
const _hoisted_55 = {
  key: 0,
  class: "card-body bg-body p-3 text-center"
}
const _hoisted_56 = /*#__PURE__*/_createElementVNode("h6", { class: "text-dark" }, "Keine Daten vorhanden ", -1)
const _hoisted_57 = /*#__PURE__*/_createElementVNode("a", {
  href: "#",
  class: "btn btn-link"
}, "Zu den ...", -1)
const _hoisted_58 = [
  _hoisted_56,
  _hoisted_57
]
const _hoisted_59 = {
  key: 1,
  class: "media-list media-list-bordered"
}
const _hoisted_60 = { key: 0 }
const _hoisted_61 = { class: "media" }
const _hoisted_62 = /*#__PURE__*/_createElementVNode("div", { class: "mr-3" }, [
  /*#__PURE__*/_createElementVNode("a", {
    href: "#",
    class: "btn bg-transparent border-blue text-blue rounded-pill border-2 btn-icon"
  }, [
    /*#__PURE__*/_createElementVNode("i", { class: "icon-user" })
  ])
], -1)
const _hoisted_63 = { class: "media-body" }
const _hoisted_64 = { class: "text-muted" }
const _hoisted_65 = /*#__PURE__*/_createElementVNode("div", { class: "ml-3" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "badge text-uppercase bg-danger" }, "Noch nicht bestätigt")
], -1)
const _hoisted_66 = { class: "card" }
const _hoisted_67 = /*#__PURE__*/_createElementVNode("div", { class: "card-header" }, [
  /*#__PURE__*/_createElementVNode("h6", { class: "card-title" }, " Letzte Alarme ")
], -1)
const _hoisted_68 = {
  key: 0,
  class: "card-body bg-body p-3 text-center"
}
const _hoisted_69 = /*#__PURE__*/_createElementVNode("h6", { class: "text-dark" }, "Keine Daten vorhanden ", -1)
const _hoisted_70 = /*#__PURE__*/_createElementVNode("a", {
  href: "#",
  class: "btn btn-link"
}, "Zu den ...", -1)
const _hoisted_71 = [
  _hoisted_69,
  _hoisted_70
]
const _hoisted_72 = {
  key: 1,
  class: "media-list media-list-linked media-list-bordered"
}
const _hoisted_73 = ["onClick"]
const _hoisted_74 = { class: "mr-3" }
const _hoisted_75 = {
  href: "#",
  class: "btn bg-transparent border-danger text-danger rounded-pill border-2 btn-icon"
}
const _hoisted_76 = { class: "media-body" }
const _hoisted_77 = { class: "text-muted" }
const _hoisted_78 = /*#__PURE__*/_createElementVNode("div", { class: "ml-3" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "list-icons" }, [
    /*#__PURE__*/_createElementVNode("a", {
      href: "#",
      class: "list-icons-item"
    }, [
      /*#__PURE__*/_createElementVNode("i", { class: "icon-arrow-right15" })
    ])
  ])
], -1)
const _hoisted_79 = /*#__PURE__*/_createElementVNode("i", { class: "icon-menu" }, null, -1)
const _hoisted_80 = [
  _hoisted_79
]
const _hoisted_81 = { class: "card" }
const _hoisted_82 = /*#__PURE__*/_createElementVNode("div", { class: "card-header" }, [
  /*#__PURE__*/_createElementVNode("h6", { class: "card-title" }, "Fehlalarme")
], -1)
const _hoisted_83 = {
  key: 0,
  class: "card-body bg-body p-3 text-center"
}
const _hoisted_84 = /*#__PURE__*/_createElementVNode("h6", { class: "text-dark" }, "Keine Daten vorhanden ", -1)
const _hoisted_85 = /*#__PURE__*/_createElementVNode("a", {
  href: "#",
  class: "btn btn-link"
}, "Zu den ...", -1)
const _hoisted_86 = [
  _hoisted_84,
  _hoisted_85
]
const _hoisted_87 = {
  key: 1,
  class: "media-list media-list-linked media-list-bordered"
}
const _hoisted_88 = ["onClick"]
const _hoisted_89 = { class: "mr-3" }
const _hoisted_90 = {
  href: "#",
  class: "btn bg-transparent border-warning text-warning rounded-pill border-2 btn-icon"
}
const _hoisted_91 = { class: "media-body" }
const _hoisted_92 = { class: "text-muted" }
const _hoisted_93 = /*#__PURE__*/_createElementVNode("div", { class: "ml-3" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "list-icons" }, [
    /*#__PURE__*/_createElementVNode("a", {
      href: "#",
      class: "list-icons-item"
    }, [
      /*#__PURE__*/_createElementVNode("i", { class: "icon-arrow-right15" })
    ])
  ])
], -1)
const _hoisted_94 = /*#__PURE__*/_createElementVNode("i", { class: "icon-menu" }, null, -1)
const _hoisted_95 = [
  _hoisted_94
]
const _hoisted_96 = { class: "card" }
const _hoisted_97 = /*#__PURE__*/_createElementVNode("div", { class: "card-header" }, [
  /*#__PURE__*/_createElementVNode("h6", { class: "card-title" }, "Unbestätigte Benutzer")
], -1)
const _hoisted_98 = {
  key: 0,
  class: "card-body bg-body p-3 text-center"
}
const _hoisted_99 = /*#__PURE__*/_createElementVNode("h6", { class: "text-dark" }, "Keine Daten vorhanden ", -1)
const _hoisted_100 = /*#__PURE__*/_createElementVNode("a", {
  href: "#",
  class: "btn btn-link"
}, "Zu den ...", -1)
const _hoisted_101 = [
  _hoisted_99,
  _hoisted_100
]
const _hoisted_102 = {
  key: 1,
  class: "media-list media-list-linked media-list-bordered"
}
const _hoisted_103 = ["onClick"]
const _hoisted_104 = /*#__PURE__*/_createElementVNode("div", { class: "mr-3" }, [
  /*#__PURE__*/_createElementVNode("a", {
    href: "#",
    class: "btn bg-transparent border-blue text-blue rounded-pill border-2 btn-icon"
  }, [
    /*#__PURE__*/_createElementVNode("i", { class: "icon-user" })
  ])
], -1)
const _hoisted_105 = { class: "media-body" }
const _hoisted_106 = { class: "text-muted" }
const _hoisted_107 = /*#__PURE__*/_createElementVNode("div", { class: "ml-3" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "list-icons" }, [
    /*#__PURE__*/_createElementVNode("a", {
      href: "#",
      class: "list-icons-item"
    }, [
      /*#__PURE__*/_createElementVNode("i", { class: "icon-arrow-right15" })
    ])
  ])
], -1)
const _hoisted_108 = /*#__PURE__*/_createElementVNode("i", { class: "icon-menu" }, null, -1)
const _hoisted_109 = [
  _hoisted_108
]
const _hoisted_110 = { class: "col-12 col-lg-12" }
const _hoisted_111 = { class: "card" }
const _hoisted_112 = { class: "card-header d-flex flex-row justify-content-between align-items-center" }
const _hoisted_113 = { class: "card-title d-flex flex-column" }
const _hoisted_114 = /*#__PURE__*/_createElementVNode("span", null, "Anlagen - Logs", -1)
const _hoisted_115 = { class: "text-muted" }
const _hoisted_116 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-refresh" }, null, -1)
const _hoisted_117 = [
  _hoisted_116
]
const _hoisted_118 = {
  key: 0,
  class: "card-body bg-body p-3 text-center"
}
const _hoisted_119 = /*#__PURE__*/_createElementVNode("h6", { class: "text-dark" }, "Keine Daten vorhanden ", -1)
const _hoisted_120 = /*#__PURE__*/_createElementVNode("a", {
  href: "#",
  class: "btn btn-link"
}, "Zu den ...", -1)
const _hoisted_121 = [
  _hoisted_119,
  _hoisted_120
]
const _hoisted_122 = {
  key: 1,
  class: "media-list media-list-linked media-list-bordered"
}
const _hoisted_123 = {
  href: "#",
  class: "media"
}
const _hoisted_124 = { class: "mr-3" }
const _hoisted_125 = {
  key: 0,
  class: "fal fa-temperature-up"
}
const _hoisted_126 = {
  key: 1,
  class: "fal fa-temperature-down"
}
const _hoisted_127 = { class: "media-body" }
const _hoisted_128 = { class: "text-muted" }
const _hoisted_129 = { key: 0 }
const _hoisted_130 = { key: 1 }
const _hoisted_131 = /*#__PURE__*/_createElementVNode("i", { class: "icon-menu" }, null, -1)
const _hoisted_132 = [
  _hoisted_131
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CounterCircle = _resolveComponent("CounterCircle")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("h5", _hoisted_6, [
              _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.armingSystem), 1),
              _hoisted_8,
              _hoisted_9
            ])
          ]),
          _createElementVNode("div", _hoisted_10, [
            _createVNode(_component_CounterCircle, {
              size: 200,
              max: parseInt(_ctx.armingTimeStart),
              count: parseInt(_ctx.armingTime),
              value: _ctx.armingTime,
              unit: 'sekunden',
              prefix: 'wird in',
              suffix: _ctx.armingText+' geschalten'
            }, null, 8, ["max", "count", "value", "suffix"]),
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("span", _hoisted_12, "Versuch: " + _toDisplayString(_ctx.tryArmingCounter) + " / 2", 1)
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("h1", _hoisted_13, "Guten Tag " + _toDisplayString(_ctx.user.firstName) + " " + _toDisplayString(_ctx.user.lastName), 1),
    _createElementVNode("div", _hoisted_14, [
      _createElementVNode("div", _hoisted_15, [
        _createElementVNode("div", _hoisted_16, [
          _createElementVNode("div", _hoisted_17, [
            _createElementVNode("h6", _hoisted_18, [
              _hoisted_19,
              _createElementVNode("small", _hoisted_20, "zuletzt Aktualisiert: " + _toDisplayString(_ctx.lastSystemRequest), 1)
            ]),
            _createElementVNode("button", {
              class: "btn btn-link text-primary",
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.getSystems && _ctx.getSystems(...args)))
            }, _hoisted_22)
          ]),
          (_ctx.systems.length <= 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_23, _hoisted_26))
            : (_openBlock(), _createElementBlock("ul", _hoisted_27, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.systems, (system, index) => {
                  return (_openBlock(), _createElementBlock("li", {
                    key: index,
                    class: "cursor-pointer"
                  }, [
                    _createElementVNode("a", {
                      class: "media d-flex flex-row align-items-center",
                      onClick: _withModifiers(($event: any) => (_ctx.goToSystems(system)), ["stop"])
                    }, [
                      _createElementVNode("div", _hoisted_29, [
                        _createElementVNode("a", {
                          href: "#",
                          class: _normalizeClass(["btn bg-transparent border-success text-success rounded-pill border-2 btn-icon ml-3 mr-3", ['border-'+system.eventClass, 'text-'+system.eventClass]])
                        }, [
                          _createElementVNode("i", {
                            class: _normalizeClass(system.icon)
                          }, null, 2)
                        ], 2),
                        _createElementVNode("small", {
                          class: _normalizeClass(["badge badge-pill ml-auto mr-auto", 'text-'+system.eventClass])
                        }, _toDisplayString(system.eventName), 3)
                      ]),
                      _createElementVNode("div", _hoisted_30, [
                        _createElementVNode("div", _hoisted_31, [
                          _createElementVNode("div", null, _toDisplayString(system.anlage_bemerkung), 1),
                          _createElementVNode("div", _hoisted_32, [
                            _createTextVNode(_toDisplayString(system.anlage_typ) + " | ", 1),
                            _createElementVNode("small", null, _toDisplayString(system.anlage_nummer), 1)
                          ]),
                          _createElementVNode("small", _hoisted_33, _toDisplayString(system.last), 1),
                          _createElementVNode("small", _hoisted_34, _toDisplayString(system.next), 1)
                        ]),
                        (system.switchManually && _ctx.user.rights.arming?.write && system.armingBySystem)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
                              (system.isTypeHikvision)
                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                    (system.eventState == 100)
                                      ? (_openBlock(), _createElementBlock("a", {
                                          key: 0,
                                          type: "button",
                                          class: "btn bg-danger-800 btn-sm w-100 w-lg-auto",
                                          onClick: _withModifiers(($event: any) => (_ctx.setArming(system, true, system.anlage_id)), ["stop"])
                                        }, _hoisted_39, 8, _hoisted_36))
                                      : (_openBlock(), _createElementBlock("a", {
                                          key: 1,
                                          type: "button",
                                          class: "btn btn-primary text-white btn-sm w-100 w-lg-auto",
                                          onClick: _withModifiers(($event: any) => (_ctx.setArming(system, false, system.anlage_id)), ["stop"])
                                        }, _hoisted_43, 8, _hoisted_40))
                                  ], 64))
                                : _createCommentVNode("", true),
                              (!system.isTypeHikvision)
                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                    (system.eventState == 100)
                                      ? (_openBlock(), _createElementBlock("a", {
                                          key: 0,
                                          type: "button",
                                          class: "btn bg-danger-800 btn-sm w-100 w-lg-auto",
                                          onClick: _withModifiers(($event: any) => (_ctx.setArming(system, true, system.anlage_id)), ["stop"])
                                        }, _hoisted_47, 8, _hoisted_44))
                                      : (_openBlock(), _createElementBlock("a", {
                                          key: 1,
                                          type: "button",
                                          class: "btn btn-primary text-white btn-sm w-100 w-lg-auto",
                                          onClick: _withModifiers(($event: any) => (_ctx.setArming(system, false, system.anlage_id)), ["stop"])
                                        }, _hoisted_51, 8, _hoisted_48))
                                  ], 64))
                                : _createCommentVNode("", true)
                            ]))
                          : _createCommentVNode("", true)
                      ])
                    ], 8, _hoisted_28)
                  ]))
                }), 128))
              ]))
        ])
      ]),
      _createElementVNode("div", _hoisted_52, [
        (_ctx.user.role=='10')
          ? (_openBlock(), _createElementBlock("div", _hoisted_53, [
              _hoisted_54,
              (_ctx.importedContacts.length <= 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_55, _hoisted_58))
                : (_openBlock(), _createElementBlock("ul", _hoisted_59, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.importedContacts, (user, index) => {
                      return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
                        (index <= 1)
                          ? (_openBlock(), _createElementBlock("li", _hoisted_60, [
                              _createElementVNode("a", _hoisted_61, [
                                _hoisted_62,
                                _createElementVNode("div", _hoisted_63, [
                                  _createTextVNode(_toDisplayString(user.headline) + " ", 1),
                                  _createElementVNode("div", _hoisted_64, _toDisplayString(user.text), 1)
                                ]),
                                _hoisted_65
                              ])
                            ]))
                          : _createCommentVNode("", true)
                      ], 64))
                    }), 128))
                  ])),
              (_ctx.importedContacts.length > 0)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 2,
                    class: "card-footer text-center hover cursor-pointer",
                    onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.goToImportedUsers && _ctx.goToImportedUsers(...args)))
                  }, " Kontakte bestätigen "))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_66, [
          _hoisted_67,
          (_ctx.lastAlerts.length <= 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_68, _hoisted_71))
            : (_openBlock(), _createElementBlock("ul", _hoisted_72, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.lastAlerts, (alert, index) => {
                  return (_openBlock(), _createElementBlock("li", {
                    key: index,
                    class: ""
                  }, [
                    _createElementVNode("a", {
                      href: "#",
                      class: "media",
                      onClick: _withModifiers(($event: any) => (_ctx.showAlert(alert)), ["prevent"])
                    }, [
                      _createElementVNode("div", _hoisted_74, [
                        _createElementVNode("a", _hoisted_75, [
                          _createElementVNode("i", {
                            class: _normalizeClass(alert.icon)
                          }, null, 2)
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_76, [
                        _createTextVNode(_toDisplayString(alert.headline) + " ", 1),
                        _createElementVNode("div", _hoisted_77, _toDisplayString(alert.text), 1)
                      ]),
                      _hoisted_78
                    ], 8, _hoisted_73)
                  ]))
                }), 128))
              ])),
          (_ctx.lastAlerts.length > 0)
            ? (_openBlock(), _createElementBlock("div", {
                key: 2,
                class: "card-footer text-center hover cursor-pointer",
                onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.goToAlerts && _ctx.goToAlerts(...args)))
              }, _hoisted_80))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_81, [
          _hoisted_82,
          (_ctx.failAlerts.length <= 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_83, _hoisted_86))
            : (_openBlock(), _createElementBlock("ul", _hoisted_87, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.failAlerts, (alert, index) => {
                  return (_openBlock(), _createElementBlock("li", {
                    key: index,
                    class: ""
                  }, [
                    _createElementVNode("a", {
                      href: "#",
                      class: "media",
                      onClick: _withModifiers(($event: any) => (_ctx.showAlert(alert)), ["prevent"])
                    }, [
                      _createElementVNode("div", _hoisted_89, [
                        _createElementVNode("a", _hoisted_90, [
                          _createElementVNode("i", {
                            class: _normalizeClass(alert.icon)
                          }, null, 2)
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_91, [
                        _createTextVNode(_toDisplayString(alert.headline) + " ", 1),
                        _createElementVNode("div", _hoisted_92, _toDisplayString(alert.text), 1)
                      ]),
                      _hoisted_93
                    ], 8, _hoisted_88)
                  ]))
                }), 128))
              ])),
          (_ctx.failAlerts.length > 0)
            ? (_openBlock(), _createElementBlock("div", {
                key: 2,
                class: "card-footer text-center hover cursor-pointer",
                onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.goToAlerts && _ctx.goToAlerts(...args)))
              }, _hoisted_95))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_96, [
          _hoisted_97,
          (_ctx.unconfirmedUsers.length <= 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_98, _hoisted_101))
            : (_openBlock(), _createElementBlock("ul", _hoisted_102, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.unconfirmedUsers, (user, index) => {
                  return (_openBlock(), _createElementBlock("li", {
                    key: index,
                    class: "cursor-pointer"
                  }, [
                    _createElementVNode("a", {
                      class: "media",
                      onClick: ($event: any) => (_ctx.showUser(user))
                    }, [
                      _hoisted_104,
                      _createElementVNode("div", _hoisted_105, [
                        _createTextVNode(_toDisplayString(user.headline) + " ", 1),
                        _createElementVNode("div", _hoisted_106, _toDisplayString(user.text), 1)
                      ]),
                      _hoisted_107
                    ], 8, _hoisted_103)
                  ]))
                }), 128))
              ])),
          (_ctx.unconfirmedUsers.length > 0)
            ? (_openBlock(), _createElementBlock("div", {
                key: 2,
                class: "card-footer text-center hover cursor-pointer",
                onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.goToUsers && _ctx.goToUsers(...args)))
              }, _hoisted_109))
            : _createCommentVNode("", true)
        ])
      ]),
      _createElementVNode("div", _hoisted_110, [
        _createElementVNode("div", _hoisted_111, [
          _createElementVNode("div", _hoisted_112, [
            _createElementVNode("h6", _hoisted_113, [
              _hoisted_114,
              _createElementVNode("small", _hoisted_115, "zuletzt Aktualisiert: " + _toDisplayString(_ctx.lastSystemLogsRequest), 1)
            ]),
            _createElementVNode("button", {
              class: "btn btn-link text-primary",
              onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.getSystemLogs && _ctx.getSystemLogs(...args)))
            }, _hoisted_117)
          ]),
          (_ctx.systemLogs.length <= 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_118, _hoisted_121))
            : (_openBlock(), _createElementBlock("ul", _hoisted_122, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.systemLogs, (log, logIndex) => {
                  return (_openBlock(), _createElementBlock("li", {
                    key: logIndex,
                    class: ""
                  }, [
                    _createElementVNode("a", _hoisted_123, [
                      _createElementVNode("div", _hoisted_124, [
                        _createElementVNode("a", {
                          href: "#",
                          class: _normalizeClass(["btn bg-transparent rounded-pill border-2 btn-icon", 'text-'+log.class+' border-'+log.class])
                        }, [
                          (log.isTypeHikvision)
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                (log.eventId == '200')
                                  ? (_openBlock(), _createElementBlock("i", _hoisted_125))
                                  : _createCommentVNode("", true),
                                (log.eventId == '100')
                                  ? (_openBlock(), _createElementBlock("i", _hoisted_126))
                                  : _createCommentVNode("", true)
                              ], 64))
                            : _createCommentVNode("", true),
                          (!log.isTypeHikvision)
                            ? (_openBlock(), _createElementBlock("i", {
                                key: 1,
                                class: _normalizeClass(log.icon)
                              }, null, 2))
                            : _createCommentVNode("", true)
                        ], 2)
                      ]),
                      _createElementVNode("div", _hoisted_127, [
                        _createTextVNode(_toDisplayString(log.anlage_bemerkung) + " | " + _toDisplayString(log.anlage_typ) + " | ", 1),
                        _createElementVNode("small", null, _toDisplayString(log.system), 1),
                        _createElementVNode("div", _hoisted_128, [
                          _createTextVNode(_toDisplayString(_ctx.formatDateTime(log.createdAt)) + " | " + _toDisplayString(log.event) + " ", 1),
                          (log.component)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_129, " | " + _toDisplayString(log.component), 1))
                            : _createCommentVNode("", true),
                          (log.reason != '')
                            ? (_openBlock(), _createElementBlock("span", _hoisted_130, ": " + _toDisplayString(log.reason), 1))
                            : _createCommentVNode("", true)
                        ])
                      ])
                    ])
                  ]))
                }), 128))
              ])),
          (_ctx.systemLogs.length > 0)
            ? (_openBlock(), _createElementBlock("div", {
                key: 2,
                class: "card-footer text-center hover cursor-pointer",
                onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.goToSystemlogs && _ctx.goToSystemlogs(...args)))
              }, _hoisted_132))
            : _createCommentVNode("", true)
        ])
      ])
    ])
  ]))
}